import type { FC } from "react";
import Button from "react-bootstrap/Button";
import { useTranslation } from "react-i18next";

import { Lightbox } from "components/Lightbox";
import Video from "components/Video/Video";

interface Props {
  themeName: string;
  videoTips: Array<{
    videoId: string;
    previewImage?: string | null | undefined;
  }>;
  onClose: () => void;
}

const VideoModal: FC<Props> = ({ themeName, videoTips, onClose }) => {
  const { t } = useTranslation("tutoring");

  return (
    // Nadpis (téma je dynamické, ale sám nadpis je vždy přítomný) zůstává v těle a jen
    // pojmenuje dialog — ne obrazový popisek videa, je to titulek celého lightboxu. [TD-344]
    <Lightbox
      show={true}
      onHide={onClose}
      size="xl"
      bodyTitleId="video-modal-title"
      // AIDEV-NOTE: `Modal.Footer` nemá přes `Lightbox` cestu na vlastní `className`
      // (`footer` prop obaluje jen obsah) — `mx-auto` na tlačítku samotném dosáhne
      // stejného centrování ve výchozím `justify-content: flex-end` patičky. [TD-344]
      footer={
        <Button variant="azure" onClick={onClose} className="px-5 mx-auto">
          <div className="px-5">{t("modal.close")}</div>
        </Button>
      }
    >
      <h2 id="video-modal-title" className="fs-16 text-center mb-20px">
        {t("modal.title")}: {themeName}
      </h2>
      <div className="tutoring__videos">
        {videoTips.map(({ videoId, previewImage }) => (
          <Video key={videoId} videoId={videoId} previewImage={previewImage} />
        ))}
      </div>
    </Lightbox>
  );
};

export default VideoModal;
